module.exports = "<!--The content below is only a placeholder and can be replaced.-->\n<app-menu></app-menu>\n<div class=\"container-fluid\" style=\"padding-bottom: 3em;\">\n    <router-outlet></router-outlet>\n</div>\n<app-preloader></app-preloader>\n<app-footer></app-footer>"


//////////////////
// WEBPACK FOOTER
// /root/anvel/angular/app/app.component.html
// module id = ../../../../../angular/app/app.component.html
// module chunks = 1